export default {
    // ----------Title----------
    reports: '报表',
    containersReport: '货柜报表',
    productsReport: '商品报表',
    productItemsReport: '商品物品详细报表',
    selectLocations: '选择仓库',
    scopeTheRangeOfTheSearchLocations: '搜索限定位置的范围',
    dataFilters: '筛选数据',
    multipleFiltersApplyToDatasetResults: '多个筛选应用于数据集结果',
    selectSearchLocation: '选择搜仓库',
    youCanSelectMultipleWarehouseLocationsToProceed: '您可以选择多个仓库位置进行操作',

    exportAllToExcel: `导出全部到EXCEL`,

    // ----------Drawer---------
    advancedFilters: '高级筛选',

    // -----------MUI----------
    createDateFrom: '创建日期(始)',
    createDateTo: '创建日期(至)',
    checkedInAtFrom: '入仓时间(始)',
    checkedInAtTo: '入仓时间(至)',
    loadDateFrom: '装柜日期(始)',
    loadDateTo: '装柜日期(至)',
    startQuery: '开始查询',
    customerMarking: '客户唛头',
    supplierName: '供应商名称',
    supplierContact: '供应商联系号',
    supplierPNo: '供应商采购号',
    applyFilters: '开始筛选',
    companyPNo: '企业采购号',
    courierNo: '运单号',
    containerId: '货柜 ID',
    signedBy: '收件人',
    createdDateTime: '创建日期',
    loadStatus: '装柜状态',
    containerNo: '货柜号',
    id: 'ID',
    depositFee: '代付定金',
    transportFee: '代付运费',

    location: '仓库',
    toLocation: '目的地',
    containerMarking: '货柜唛头',
    createdBy: '创建账号',
}